import React, { useState } from 'react';
import './ContactForm.scss';
import icon from '../../assets/banner/icons/Calling.png';

const ContactForm = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        service: '',
        department: '',
        message: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const phone = '918904674189'; // Doctor's WhatsApp number with country code for India
        const message = `Hello Dr. Bhagat Tanwar,%0A%0A` +
                `I hope this message finds you well.%0A%0A` +
                `My name is *${formData.name}* and I am interested in your *${formData.service}* service.%0A%0A` +
                `Here are my details:%0A` +
                `- *Email*: ${formData.email}%0A` +
                `- *Department*: ${formData.department}%0A` +
                `- *Message*: ${formData.message}%0A%0A` +
                `Looking forward to your response.%0A%0A` +
                `Thank you!%0A` +
                `Best regards,%0A` +
                `${formData.name}`;

        const url = `https://wa.me/${phone}?text=${message}`;
        window.open(url, '_blank'); // Opens WhatsApp in a new tab
    };
    

    return (
        <form onSubmit={handleSubmit}>
            <div className="row">
                <div className="col-lg-6">
                    <div className="form-group">
                        <label>Name</label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter your name..."
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                        />
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="form-group">
                        <label>E-mail Address</label>
                        <input
                            type="email"
                            className="form-control"
                            placeholder="Enter email address..."
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                        />
                    </div>
                </div>
                <div className="col-lg-6">
  <div className="form-group">
    <label>Service</label>
    <select
      className="form-control"
      name="service"
      value={formData.service}
      onChange={handleChange}
    >
      <option value="">Select a Service</option>

      {/* Root Canal Treatments */}
      <option value="Root Canal Treatment">Root Canal Treatment</option>
      <option value="Micro Endodontics - Single Visit RCT">Micro Endodontics – Single Visit RCT</option>

      {/* Braces & Orthodontics */}
      <option value="Braces Treatment">Braces Treatment</option>
      <option value="Metal Braces">Metal Braces</option>
      <option value="Self Ligating Advanced Braces">SELF LIGATING ADVANCED BRACES</option>
      <option value="Damon Braces">Damon Braces</option>
      <option value="Ceramic Braces">Ceramic Braces</option>
      <option value="Invisalign (USA)">INVISALIGN (USA)</option>

      {/* Cosmetic & General */}
      <option value="Teeth Whitening">Teeth Whitening</option>

      {/* Restorative */}
      <option value="Dental Implants">Dental Implants</option>
      <option value="Implants">Implants</option>
      <option value="Dentures">Dentures</option>
    </select>
  </div>
</div>

                {/* <div className="col-lg-6">
                    <div className="form-group">
                        <label>Department</label>
                        <select
                            className="form-control"
                            name="department"
                            value={formData.department}
                            onChange={handleChange}
                        >
                            <option value="">Select Department</option>
                            <option value="General Dentistry">General Dentistry</option>
                            <option value="Orthodontics">Orthodontics</option>
                            <option value="Endodontics">Endodontics</option>
                            <option value="Cosmetic Dentistry">Cosmetic Dentistry</option>
                        </select>
                    </div>
                </div> */}
                <div className="col-lg-12">
                    <div className="form-group">
                        <label>Messages</label>
                        <textarea
                            className="form-control"
                            placeholder="Enter your messages..."
                            rows="3"
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                        ></textarea>
                    </div>
                </div>

                <div className="col-lg-6">
                    <button type="submit" className="btn appointment-btn">
                        Book an appointment
                    </button>
                </div>
                <div className="col-lg-6">
                    <div className="appointment-call">
                        <div className="icon">
                            <img src={icon} alt="icon" />
                        </div>
                        <div className="call-text">
                            <p>Dental 24H Emergency</p>
                            <h6>8904674189</h6>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    );
};

export default ContactForm;
